import React, { Component } from "react";
import { Breadcrumbs, Table, Search, Img, Skeleton } from "components/index";
import { GET, POST } from "../../../../../api/api";
import swal from "sweetalert";

export default class CarModel extends Component {
     constructor(props) {
          super(props);
          this.state = {
               series: [],
               series_backup: [],
               search: {},
               fileTextHolder: "",
               loading: false,
          };
     }

     componentDidMount = () => {
          this.getSeries();
     };

     getSeries = async () => {
          try {
               let series = await GET("/aos/get_series");
               series
                    .sort((end, start) => parseFloat(start.series_id) - parseFloat(end.series_id))
                    .sort((end, start) => parseFloat(start.series_id) - parseFloat(end.series_id));
               this.setState({ series: [...series], series_backup: [...series] });
          } catch (error) {
               console.log(error);
          }
     };
     /* ----------------------------- Handle --------------------------- */
     handleClick = () => {
          window.location.assign("/admin/car-model/detail/add");
     };
     /* --------------------------- Formatter -------------------------- */
     editFormatter(cell, row, rowIndex, formatExtraData) {
          return (
               <i
                    style={{ cursor: "pointer" }}
                    className="fas fa-pen-square"
                    onClick={() => window.location.assign(`/admin/car-model/detail/edit/${row.series_id}`)}
               ></i>
          );
     }

     handleChange = (event) => {
          // console.log(event);
          if (event.target.files[0]) {
               const fileUploaded = event.target.files[0];
               this.setState({
                    file: fileUploaded,
                    fileTextHolder: fileUploaded.name,
               });
          }
     };

     handleUploadFile = async () => {
          const { file } = this.state;
          try {
               let formData = new FormData();
               if (file) {
                    formData.append("type", "series_master");
                    formData.append("file", file);

                    this.setState({ loading: true });
                    await POST("/aos/series_master", formData, true);
                    await this.getSeries();
                    this.setState({ loading: false, fileTextHolder: "", file: null });
               }
          } catch (error) {
               swal({
                    text: error,
                    icon: "warning",
                    button: "ตกลง",
                    dangerMode: true,
               });
               this.setState({ loading: false });
          }
     };

     onSearch = () => {
          let { series_backup, search } = this.state;
          // console.log("promotion_backup", promotion_backup)
          // console.log(search)
          let series = series_backup.filter(
               (e) =>
                    (search.series_code ? String(e.series_code).toLowerCase().includes(String(search.series_code).toLowerCase()) : e) &&
                    (search.series_name ? String(e.series_name).toLowerCase().includes(String(search.series_name).toLowerCase()) : e) &&
                    (search.model
                         ? String(e.model).toLowerCase() === String(search.model).toLowerCase() ||
                           String(search.model).toLowerCase() === String("ทั้งหมด")
                         : e) &&
                    (search.status
                         ? String(e.status).toLowerCase() === String(search.status).toLowerCase() ||
                           String(search.status).toLowerCase() === String("ทั้งหมด")
                         : e)
          );
          this.setState({ series });
          // console.log("promotion", promotion)
     };
     handleChangeText = (e) => {
          // handle by name
          let { search } = this.state;
          search[e.target.name] = e.target.value;
          this.setState({ ...search });
     };
     handleChangeOption = (e) => {
          // handle option by name
          let { search } = this.state;
          search[e.target.name] = e.target.value;
          this.setState({ ...search });
     };

     downloadFile = async () => {
          try {
               window.open(await POST("/ps/download_excel", { download: "car" }));
          } catch (error) {
               swal({
                    text: "ดาวน์โหลดไม่สำเร็จ",
                    icon: "warning",
                    button: "ตกลง",
                    dangerMode: true,
               });
          }
     };

     render() {
          let { series, fileTextHolder, loading, search, series_backup } = this.state;
          let obj = {
               series: series_backup?.map((e) => ({
                    value: e.series_name,
                    name: e.series_name,
               })),
          };
          const table = {
               column: [
                    {
                         dataField: "edit",
                         text: "ข้อมูล",
                         formatter: this.editFormatter,
                         headerClasses: "header-custom __left __icon",
                    },
                    {
                         dataField: "series_code",
                         text: "Series Code",
                         headerClasses: "header-custom __btn-ml",
                    },
                    {
                         dataField: "series_name",
                         text: "Series",
                         headerClasses: "header-custom __btn-ml",
                    },
                    {
                         dataField: "type",
                         text: "ประเภทรถ",
                         headerClasses: "header-custom __btn-m",
                    },
                    {
                         dataField: "status",
                         text: "สถานะ",
                         headerClasses: "header-custom __right __btn-ss",
                    },
               ],
               keyField: "series_name",
          };
          return (
               // <div className="panel hide-scroll">
               <div className="panel">
                    <Breadcrumbs
                         title={[{ title: "รุ่นรถ" }]}
                         active={0}
                         button={
                              [
                                   // {
                                   //      icon: "far fa-plus-square -icon",
                                   //      name: "เพิ่มรุ่นรถ",
                                   //      handleClick: this.handleClick,
                                   // },
                              ]
                         }
                    />
                    <div className="content __main-panel">
                         <div className="search-bar">
                              <Search
                                   type={"car-model"}
                                   searchOptions={search}
                                   onSearch={this.onSearch}
                                   handleChangeText={this.handleChangeText}
                                   handleChange={this.handleChangeOption}
                                   obj={obj}
                              />
                              <Search
                                   className="w-100 pr-5"
                                   type={"upload"}
                                   title={{
                                        name: "อัปโหลด Car Master",
                                        icon: Img.excel,
                                   }}
                                   placeholder={fileTextHolder !== "" ? fileTextHolder : "ไฟล์.csv"}
                                   button={"แนบไฟล์"}
                                   style_id={"custom-btn __below-btn"}
                                   handleChange={this.handleChange}
                                   handleUploadFile={this.handleUploadFile}
                                   downloadFile={this.downloadFile}
                                   disabled={loading}
                              />
                         </div>
                         {loading ? (
                              <Skeleton type={"index"} column={table.column} />
                         ) : (
                              <Table type={"index-fixhead"} column={table.column} data={series} keyField={table.keyField} />
                         )}
                    </div>
               </div>
          );
     }
}
